import {
  getTopLevelHeaderName,
  getSubLevelHeaderName,
  getSectionName,
} from './utils/quickLinksTelemetryHelpers';

export default function (telemetry, navData) {
  const sharedNavContainer = document.getElementById('shared-nav');
  if (!sharedNavContainer) {
    return;
  }

  const quickLinks = [].slice.call(sharedNavContainer.querySelectorAll('.shared-nav__link-list-anchor'));

  if (!telemetry || typeof telemetry.makeEvent !== 'function') {
    return;
  }

  quickLinks.forEach((quickLink) => {
    const sectionName = getSectionName(quickLink);
    const topLevelHeaderName = getTopLevelHeaderName(sectionName, navData);
    const subLevelHeaderName = getSubLevelHeaderName(quickLink);

    const data = {
      category: topLevelHeaderName,
      linkName: subLevelHeaderName,
      interactAction: `select header:${topLevelHeaderName}:${subLevelHeaderName}`,
      interactCta: `${topLevelHeaderName}:${subLevelHeaderName}`,
    };
    const telemetryData = telemetry.makeEvent({ type: 'shared-nav:click:nav-item', data });

    if (telemetryData) {
      quickLink.setAttribute('data-telemetry', telemetryData);
    }
  });
}
